
import AppContainer from "../../Components/Structure/AppContainer";
import {Toaster} from "react-hot-toast";

function AppUpdatePage() {

  return (
    <AppContainer title={"App Update Details"}>
      <Toaster position="top-center" reverseOrder={false} />

      <div className="card height-auto">
            <div className="card-body">
            
            </div>
        </div>

      

    </AppContainer>
  );
}

export default AppUpdatePage;
